var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHouseCertificateIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-8 -8 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 21.0037H17.7164C18.8218 21.0037 19.7172 20.1083 19.7172 19.0029V3.99663C19.7172 3.4444 19.269 2.99622 18.7168 2.99622H16.859C16.3068 2.99622 15.8586 3.4444 15.8586 3.99663V6.30359",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99625 10.7134L10.6975 4.11268C11.4468 3.47041 12.5522 3.47041 13.3015 4.11268L21.0037 10.7134",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55498 16.2247L7.60917 18.1705L6.44168 17.0031",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27137 17.8164L3.93564 18.6858L4.0797 19.7672C4.15974 20.3675 4.63093 20.8397 5.23118 20.9197L6.31563 21.0648L7.184 21.729C7.6642 22.0962 8.33147 22.0962 8.81167 21.729L9.68104 21.0648H9.68004L10.7625 20.9207C11.3627 20.8407 11.8349 20.3695 11.915 19.7692L12.06 18.6848C12.06 18.6858 12.3962 18.2456 12.7243 17.8164C13.0915 17.3362 13.0915 16.6689 12.7243 16.1887L12.06 15.3194L11.916 14.2379C11.8359 13.6377 11.3647 13.1655 10.7645 13.0854L9.68004 12.9404L8.81167 12.2761C8.33147 11.9089 7.6642 11.9089 7.184 12.2761L6.31463 12.9404H6.31563L5.23318 13.0844C4.63293 13.1645 4.16074 13.6357 4.0807 14.2359L3.93564 15.3204C3.93564 15.3194 3.5995 15.7595 3.27137 16.1887C2.90421 16.6689 2.90421 17.3352 3.27137 17.8164Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouseCertificateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HouseCertificateIcon.98f903cf.svg";
export { ForwardRef as ReactComponent };